import { useTheme } from '@mui/material/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import BackgroundIcon from '@components/BackgroundIcon';
import ScanAppModalContent from '@components/Modal/Content/ScanAppModalContent';
import RecordSync from '@components/RecordSync';
import WelcomeMessage from '@components/WelcomeMessage';

import { useIsMobile } from '@hooks/useIsMobile';
import { useModal } from '@hooks/useModal';
import { useSession } from '@hooks/useSession';

import AppLayout from '@layouts/AppLayout';

import { getScanAppLink, handleRenderQrCode } from '@utils/scan';

import {
  // DashFooter,
  DashWaiting,
  HealthAndStreaks, // ImproveTips,
  Metrics,
  PatientList,
  RecentRecords,
  Routines,
  UpcomingAppointments,
} from './';
import AddingButton from './AddingButton';
import {
  DashContents,
  DashboardStyle,
  MainContents,
  SecondaryContent,
} from './ClientDashboard.style';
import HealthScores from './HealthScores';

const messages = defineMessages({
  takeScan: {
    id: 'clientDashboard.takeScan',
    defaultMessage: 'Take A Scan',
  },
});

function Dashboard() {
  const { formatMessage } = useIntl();
  const mobile = useIsMobile();
  const { openModal } = useModal();
  const {
    palette: { primary },
  } = useTheme();
  const tablet = useIsMobile('lg');
  const {
    state: { activeProfile },
  } = useSession();
  const [first_name, patient_id] = [
    activeProfile?.first_name,
    activeProfile?.patient_id,
  ];

  const scanLink = getScanAppLink(activeProfile?.email);

  const handleOpenModal = () => {
    openModal({
      width: 400,
      props: {
        height: '300px',
      },
      children: <ScanAppModalContent />,
    });
  };

  const scanButton = scanLink ? (
    <AddingButton
      circle
      color={primary.main}
      iconName={[{ name: 'face-smile' }]}
      onClick={() => {
        handleRenderQrCode(scanLink, handleOpenModal);
      }}
      secondaryIconName={[
        [
          { name: 'expand', size: 'xl' },
          { name: 'person', size: 'lg', transform: { x: 2.1 } },
        ],
        [
          {
            name: 'person-dots-from-line',
          },
        ],
        [
          {
            name: 'head-side-cough',
          },
        ],
      ]}
      text={formatMessage(messages.takeScan)}
    />
  ) : null;

  return (
    <AppLayout showHeader>
      <BackgroundIcon />
      <DashboardStyle>
        {first_name ? <WelcomeMessage name={first_name} /> : null}
        {!mobile && patient_id && <RecordSync />}

        <DashContents>
          {patient_id ? (
            <>
              <MainContents>
                {mobile ? <DashWaiting /> : null}
                <Routines />
                {(mobile || tablet) && scanButton}
                <HealthScores />
                <Metrics />
                {/* <ImproveTips /> */}
                {/* {!tablet && <DashFooter />} */}
              </MainContents>

              <SecondaryContent>
                {!mobile && <DashWaiting />}
                {!mobile && !tablet && scanButton}
                <RecentRecords />
                <HealthAndStreaks />
                <UpcomingAppointments />
                {/* {tablet ? <DashFooter /> : null} */}
              </SecondaryContent>
            </>
          ) : (
            <SecondaryContent>
              <PatientList />
            </SecondaryContent>
          )}
        </DashContents>
      </DashboardStyle>
    </AppLayout>
  );
}

export default Dashboard;
